import {
  langData,
  LOGIN_ROUTE,
  resendEmailVerificationLink,
  useAppDispatch,
} from "@hypexone/uicore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";

interface ResendEmailModalProps {
  onClose: () => void;
}

export const ResendEmailModal: React.FC<ResendEmailModalProps> = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleResend = async () => {
    setMessage("");
    setError("");
    await dispatch(
      resendEmailVerificationLink({
        emailId: email.trim(),
        languageData: langData,
      })
    );
    onClose();
    navigate(LOGIN_ROUTE);
  };

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="w-full max-w-md bg-[rgba(255,255,255,.6)] border border-gray-800 rounded-xl shadow-md p-6 relative bg-white"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="resend-email-modal-title"
      >
        <h2
          id="resend-email-modal-title"
          className="text-2xl font-semibold text-black mb-3"
        >
          Resend Verification Email
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="absolute top-1 right-1 w-9 h-9 rounded-full bg-black flex items-center justify-center p-1 hover:opacity-90"
          aria-label="Close"
        >
          <IoClose className="text-white text-2xl" />
        </button>

        <div className="flex flex-col gap-3 mt-4">
          <label htmlFor="resend-email-input" className="text-sm font-medium text-black">
            Email Address
          </label>
          <input
            id="resend-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder=""
            className="px-4 py-2 border border-gray-800 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />
        </div>

        {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
        {message && <p className="text-sm text-green-600 mt-2">{message}</p>}

        <button
          onClick={handleResend}
          className="mt-5 w-full py-2 bg-button-gradient text-white font-semibold rounded-lg transition"
        >
          Resend Verification Link
        </button>
      </div>
    </div>
  );
};

export default ResendEmailModal;
